import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { ReusoAutomaticoComponent } from './reuso-automatico.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ReusoAutomaticoRoutingModule } from './reuso-automatico-routing.module';
import { ListaVendasComponent } from './lista-vendas/lista-vendas.component';
import { CadastrarVendasComponent } from './cadastrar-vendas/cadastrar-vendas.component';
import { ListarReusoCadastradoComponent } from './listar-reuso-cadastrado/listar-reuso-cadastrado.component';
import { ListarReusoVinculadoComponent } from './listar-reuso-vinculado/listar-reuso-vinculado.component';
import { ExtratoReusoAutomaticoComponent } from './extrato-reuso-automatico/extrato-reuso-automatico.component';
import { PercentageMaskDirective } from './percentage-mask.directive';
//import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    CommonModule,
    ReusoAutomaticoRoutingModule,
    FormsModule,
   // BrowserModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    CurrencyMaskModule,
  ],
  exports: [
    MyDatePickerModule,
    PercentageMaskDirective,
  ],
  declarations: [
    ReusoAutomaticoComponent,
    ListaVendasComponent,
    CadastrarVendasComponent,
    ListarReusoCadastradoComponent,
    ListarReusoVinculadoComponent,
    ExtratoReusoAutomaticoComponent,
    PercentageMaskDirective,
  ],
})
export class ReusoAutomaticoModule { }
